var ConfiguratorRoutes;
(function (ConfiguratorRoutes) {
    ConfiguratorRoutes["INDEX"] = "/";
    ConfiguratorRoutes["MODELS"] = "/models";
    ConfiguratorRoutes["VARIANTS_BASE"] = "/variants/";
    ConfiguratorRoutes["CONFIGURE"] = "/configure/:trimCode";
    ConfiguratorRoutes["CONFIGURE_TRIM"] = "/configure/:trimCode";
    ConfiguratorRoutes["TRIM_LEVELS"] = "/trim-levels/";
    ConfiguratorRoutes["STOCK_DETAIL_FROM_CUSTOMISE"] = "/stock/details";
    ConfiguratorRoutes["CONFIGURE_BASE"] = "/configure/";
})(ConfiguratorRoutes || (ConfiguratorRoutes = {}));
export default ConfiguratorRoutes;
//# sourceMappingURL=ConfiguratorRoutes.js.map